// @flow
import * as React from "react";
import styled, { css } from "styled-components";
import { fontSize, rtl } from "../../common/styled-mixins";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  min-height: 39px;
  padding: 0 0.5em;
  font-size: ${fontSize(14)};
  line-height: normal;
  color: ${props => props.theme.inputColor};
  background-color: #fff;
  border: 1px solid #cccccc;
  border-radius: 3px;
  box-shadow: inset 0px 2px 0px 0px #ebebeb;

  @media (min-width: 960px) {
    min-height: 39px;
    max-width: 220px;
    font-size: 16px;
  }

  ${props =>
    props.invalid &&
    css`
      outline: none;
      border-color: #e74c3c;
    `};

  ${props =>
    props.wide &&
    css`
      max-width: 100% !important;
      ${rtl("border-radius", "0 3px 3px 0", "3px 0 0 3px")};
    `};

  ${props =>
    props.isWithdraw &&
    css`
      box-shadow: none;
      min-height: 39px;
    `}

  ${({ theme, isProfile, isWithdraw }) =>
    theme.newIndex &&
    !isProfile &&
    !isWithdraw &&
    css`
      height: 50px;
      ${rtl("margin-left", "1px")};
      background-color: #d4d4d4;
      border: none;
      ${rtl("border-radius", "0 25px 25px 0", "25px 0 0 25px")};
      box-shadow: none;

      @media (max-width: 959px) {
        height: 40px;
      }

      & input {
        background-color: transparent;
      }
    `};

  ${({ theme, isProfile, isWithdraw, isFocused }) =>
    theme.newIndex &&
    !isProfile &&
    !isWithdraw &&
    css`
      background-color: rgba(255, 255, 255, 0.25);
      ${rtl("padding-left", "20px")};

      ${isFocused &&
        css`
          border: 1px solid #ffffff;
          ${rtl("padding-left", "19px")};
        `};
    `};
`;

const InputView = styled.input`
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 100%;
  vertical-align: middle;
  width: 100%;
  min-width: 0;
  padding: 0;
  margin: 0;
  font-size: ${fontSize(16)};
  color: ${props => props.theme.inputColor || "#1B546A"};
  background-color: transparent;
  border: none;
  appearance: none;

  :focus {
    outline: none;
  }

  ${props =>
    props.isWithdraw &&
    css`
      color: #1b546a;
      font-size: ${fontSize(16)};
      font-weight: bold;
    `}

  @media (min-width: 960px) {
    font-size: ${fontSize(16)};
  }

  ${({ theme, isProfile, isWithdraw }) =>
    theme.newIndex &&
    !isProfile &&
    !isWithdraw &&
    css`
      &::placeholder {
        color: #ffffff;
      }
    `};

  ${({ version }) =>
    version === 2 &&
    css`
      font-size: 16px;
      font-weight: 700;
      color: #1b546a;
    `};
`;

const Label = styled.label`
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  text-align: center;
  color: #a5a4a4;
`;

type Props = {
  focus?: boolean,
  isProfile?: boolean,
  showPhoneInfo?: boolean,
  onChange: (value: any) => void,
  onEnter?: (value: any) => void,
  label: React.Node,
  error: React.Node,
  val?: React.Node,
  value: React.Node,
  placeholder: React.Node,
  id: string,
  wide?: boolean
};

class Input extends React.Component<Props, {}> {
  input = React.createRef();

  onChange = (e: SyntheticEvent<HTMLInputElement>) => {
    if (typeof this.props.onChange === "function") {
      this.props.onChange(e.currentTarget.value);
    }
  };

  onEnter = (e: SyntheticKeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && typeof this.props.onEnter === "function") {
      this.props.onEnter(e.currentTarget.value);
    }
  };

  componentDidMount() {
    if (this.props.focus === true && this.input.current) {
      this.input.current.focus();
    }
  }

  render() {
    const {
      label,
      val,
      value,
      placeholder,
      error,
      id,
      isProfile,
      isWithdraw,
      showPhoneInfo,
      version,
      ...other
    } = this.props;

    return (
      <Container
        invalid={!!error}
        wide={other.wide}
        isProfile={isProfile}
        isWithdraw={isWithdraw}
        isFocused={showPhoneInfo}
      >
        {label && <Label htmlFor={id}>{label}</Label>}
        <InputView
          id={id}
          name={id}
          ref={this.input}
          placeholder={placeholder}
          defaultValue={val}
          value={value}
          onChange={this.onChange}
          onKeyUp={this.onEnter}
          autoCorrect="no"
          isProfile={isProfile}
          isWithdraw={isWithdraw}
          version={version}
          {...other}
        />
      </Container>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/ReVerification/Phone/Input.js